// Module
var code = `<div class="tradingViewPanel-symbolLookupHidder"></div> <!-- element to hide TradingView 'header_symbol_search' and 'header_compare' -->
<div class="tradingViewPanel-new-symbol-search">
    <terceraInstrumentLookup selectedItem="{{.instrumentItem}}" selectedAccount="{{account}}" mayContainTrees="true" />
</div>

<!-- TradingView Chart Container -->
<div class="tradingView-container"
     on-mouseenter="onTvChartMouseEnter"
     on-mouseleave="onTvChartMouseLeave">
    <div id="{{.widgetContainerID}}"
         class="tradingView-container {{ disablePointerEvents ? 'pointer-disabled' : '' }}">
    </div>
</div>`;
// Exports
export default code;